import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import useAuth from '../../hooks/global/useAuth';
import useMobileApp from '../../hooks/mobile-app/useMobileApp';
import useAppMethods from '../../hooks/utility/useAppMethods';

const useWelcomeBonus = (className?: string) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Carousel:DealsCarousel' });
  const { cashbackProgram, formatPointsAsMoney } = useCashbackProgram();
  const { isLoggedIn } = useAuth();
  const { isMobileApp } = useMobileApp();
  const { toggleLoginModal } = useAppMethods();

  if (isMobileApp) {
    return;
  }

  if (isLoggedIn) {
    return;
  }

  if (!cashbackProgram?.welcome_bonus) {
    return;
  }

  const bonusAmount = formatPointsAsMoney(cashbackProgram.welcome_bonus);
  const image = cashbackProgram.welcome_bonus_image_url;
  const onClick = () => {
    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => null,
    });
  };

  return {
    data: cashbackProgram.welcome_bonus,
    image,
    render: () => ({
      key: 'welcome_bonus',
      title: t('deals.welcome_bonus.title', { amount: bonusAmount }),
      description: t('deals.welcome_bonus.desc', { amount: bonusAmount }),
      className: classnames(className, 'cursor-pointer'),
      footer: t('deals.buttons.show_details'),
      onClick,
      image,
    }),
  };
};

export default useWelcomeBonus;
